import React from 'react'
import Experiment from '@mc/experiments-react'

import { EXPERIMENT_KEY } from '../hooks/useTrackPen5038ExperimentViewed'
import { HeadingTitle } from './HeadingTitle'

export const Pen5038HeadingWrapper = ({
  control,
}: {
  control: React.ReactNode
}) => (
  <Experiment
    name={EXPERIMENT_KEY}
    control={() => control}
    variant_1={HeadingTitle}
    track={false}
  />
)
